{
  "common": {
    "total": "Всего: {{count}}",
    "index": "№",
    "actions": "Действие",
    "actionsLabel": "Действия",
    "createdAt": "Время создания",
    "createdBy": "Добавил",
    "edit": "Редактировать",
    "delete": "Удалить",
    "details": "Подробнее",
    "back": "Назад",
    "cancel": "Отмена",
    "save": "Сохранить",
    "close": "Закрыть",
    "saved": "Сохранено",
    "deleted": "Удалено",
    "error": "Произошла ошибка",
    "loadError": "Не удалось загрузить данные",
    "retry": "Повторить",
    "notFound": "Ничего не найдено",
    "notFoundHint": "Попробуйте изменить запрос.",
    "clear": "Очистить",
    "required": "Заполните поле",
    "nameTaken": "Такое название уже есть",
    "codeTaken": "Такой код уже есть",
    "system": "Система",
    "none": "Не выбрано",
    "select": "Выберите",
    "unsavedTitle": "Изменения не сохранены",
    "unsavedText": "Введённые данные будут потеряны.",
    "stay": "Остаться",
    "leave": "Выйти",
    "noRight": "У вас нет прав на это действие",
    "loading": "Загрузка..."
  },
  "module": {
    "tabsLabel": "Разделы управления устройствами",
    "categories": "Категории устройств",
    "locations": "Места установки",
    "info": "Сведения об устройствах",
    "calibration": "Калибровка устройств",
    "config": "Конфигурация устройств"
  },
  "categories": {
    "title": "Категории устройств",
    "create": "Создать категорию",
    "editTitle": "Редактировать категорию",
    "search": "Поиск по названию категории",
    "column": "Категория устройства",
    "field": "Название категории",
    "placeholder": "Введите название категории",
    "empty": "Категорий нет",
    "emptyHint": "Пока не добавлено ни одной категории.",
    "deleteTitle": "Удалить категорию?",
    "deleteText": "Категория «{{name}}» будет удалена.",
    "inUseTitle": "Категорию нельзя удалить",
    "inUseText": "К этой категории привязано устройств: {{count}}.",
    "icon": "Значок",
    "color": "Цвет"
  },
  "locations": {
    "title": "Места установки",
    "create": "Создать место установки",
    "editTitle": "Редактировать место установки",
    "search": "Поиск по названию места",
    "column": "Место установки устройства",
    "field": "Название места",
    "placeholder": "Введите название места",
    "empty": "Мест установки нет",
    "emptyHint": "Пока не добавлено ни одного места установки.",
    "deleteTitle": "Удалить место установки?",
    "deleteText": "«{{name}}» будет удалено.",
    "deleteInUse": "«{{name}}» будет удалено. У устройств ({{count}}) место установки будет очищено."
  },
  "info": {
    "title": "Сведения об устройствах",
    "create": "Создать сведения об устройстве",
    "editTitle": "Редактировать сведения",
    "search": "Поиск по названию устройства",
    "category": "Категория",
    "location": "Место установки",
    "name": "Название устройства",
    "serial": "Серийный номер",
    "passport": "Паспорт",
    "passportLong": "Паспорт калибровки",
    "passportBadge": "Паспорт.{{ext}}",
    "empty": "Устройств нет",
    "emptyHint": "Нажмите «Создать сведения об устройстве», чтобы добавить первое устройство.",
    "nameLabel": "Выберите название устройства",
    "namePlaceholder": "Введите название устройства",
    "discovered": "Найдены в источниках данных",
    "codeLabel": "Код устройства",
    "codePlaceholder": "Автоматически",
    "categoryLabel": "Выберите категорию",
    "locationLabel": "Выберите место установки",
    "serialLabel": "Серийный номер",
    "serialPlaceholder": "Введите серийный номер",
    "modelLabel": "Модель",
    "modelPlaceholder": "Введите модель",
    "statusLabel": "Статус",
    "passportLabel": "Паспорт калибровки",
    "upload": "Загрузить файл",
    "uploading": "Загрузка...",
    "replaceFile": "Заменить файл",
    "removeFile": "Убрать файл",
    "passportHint": "PDF или изображение (PNG, JPG), до 100 МБ",
    "fileType": "Можно загрузить только PDF, PNG или JPG",
    "fileSize": "Размер файла не должен превышать 100 МБ",
    "created": "Устройство добавлено",
    "deleteTitle": "Удалить устройство?",
    "deleteText": "«{{name}}» и его показатели будут удалены. История измерений сохранится.",
    "viewPassport": "Открыть паспорт"
  },
  "statuses": {
    "active": "Активно",
    "inactive": "Неактивно",
    "maintenance": "На обслуживании"
  },
  "indicators": {
    "title": "Показатели",
    "add": "Добавить показатель",
    "empty": "Показателей нет",
    "saveFirst": "Чтобы добавить показатели, сначала сохраните устройство.",
    "createTitle": "Новый показатель",
    "editTitle": "Редактировать показатель",
    "name": "Название показателя",
    "namePlaceholder": "Например: Уровень воды",
    "code": "Код",
    "kind": "Тип",
    "physical": "Физический",
    "virtual": "Виртуальный",
    "unit": "Единица измерения",
    "unitPlaceholder": "Например: м",
    "precision": "Знаков после запятой",
    "thresholds": "Пороги (критерии)",
    "warningLow": "M-1 нижний",
    "warningHigh": "M-1 верхний",
    "alarmLow": "M-2 нижний",
    "alarmHigh": "M-2 верхний",
    "alarm": "Контроль критериев",
    "alarmHint": "Оповещение при выходе за пороги",
    "alarmNoRight": "Для включения нужен доступ на редактирование «Устройств»",
    "color": "Цвет",
    "chartType": "Тип диаграммы",
    "channel": "Канал единого сервера",
    "channelPlaceholder": "Например: hydro:LEVEL",
    "channelCustom": "Другой канал",
    "source": "Исходный показатель (x)",
    "formula": "Формула",
    "deleteTitle": "Удалить показатель?",
    "deleteText": "«{{name}}» будет удалён.",
    "invalidNumber": "Введите число",
    "m2High": "Верхний порог M-2 не должен быть меньше M-1",
    "m2Low": "Нижний порог M-2 не должен быть больше M-1",
    "lowHigh": "Нижний порог должен быть меньше верхнего",
    "physicalCount": "физ.: {{count}}",
    "virtualCount": "вирт.: {{count}}"
  },
  "chartTypes": {
    "auto": "Авто",
    "line": "Линейная",
    "bar": "Столбчатая",
    "area": "С областями",
    "scatter": "Точечная",
    "step": "Ступенчатая"
  },
  "colors": {
    "auto": "Авто",
    "custom": "Свой",
    "blue": "Синий",
    "green": "Зелёный",
    "darkGreen": "Тёмно-зелёный",
    "yellow": "Жёлтый",
    "orange": "Оранжевый",
    "red": "Красный",
    "pink": "Розовый",
    "purple": "Фиолетовый"
  },
  "detail": {
    "title": "Подробные сведения",
    "category": "Категория устройства",
    "location": "Место установки",
    "serial": "Серийный номер",
    "createdAt": "Время создания",
    "createdBy": "Кем создано",
    "code": "Код устройства",
    "model": "Модель",
    "status": "Статус",
    "indicators": "Показатели"
  },
  "passport": {
    "title": "Просмотр паспорта калибровки",
    "download": "Скачать",
    "missing": "Паспорт не загружен",
    "missingHint": "Загрузите паспорт калибровки в сведениях об устройстве.",
    "frameTitle": "Паспорт калибровки",
    "fullscreen": "Во весь экран"
  },
  "calibration": {
    "title": "Калибровка устройств",
    "sourceLabel": "Выберите показатель устройства",
    "sourcePlaceholder": "Выберите показатель",
    "deviceInfo": "Сведения об устройстве",
    "readingsTitle": "Показания устройства (по CSV-файлу)",
    "date": "Дата",
    "value": "Показание",
    "noReadings": "Показаний пока нет",
    "formulaTitle": "Создание формулы",
    "formulaLabel": "Введите формулу",
    "formulaPlaceholder": "Например: 0,0001 * x³ + 0,12 * x + 1",
    "formulaError": "Ошибка в формуле: {{message}}",
    "formulaHint": "x — значение выбранного показателя",
    "nameLabel": "Название показателя",
    "namePlaceholder": "Например: Блок P - 1 давление",
    "unitLabel": "Единица измерения",
    "chartLabel": "Тип диаграммы",
    "colorLabel": "Цвет",
    "newFormula": "Новая формула",
    "addFormula": "Добавить формулу",
    "deleteFormula": "Удалить формулу",
    "deleteTitle": "Удалить формулу?",
    "deleteText": "Виртуальный показатель «{{name}}» будет удалён.",
    "empty": "Физических показателей нет",
    "emptyHint": "Для калибровки сначала добавьте устройство и его физический показатель.",
    "pickSource": "Выберите физический показатель для калибровки",
    "readOnly": "У вас нет прав на изменение формул",
    "virtualCount": "Виртуальные показатели"
  },
  "config": {
    "title": "Конфигурация устройств",
    "search": "Поиск по названию устройства",
    "create": "Добавить устройство",
    "code": "Код",
    "name": "Название",
    "category": "Категория",
    "location": "Место",
    "source": "Источник",
    "lastReading": "Последнее значение",
    "status": "Статус",
    "indicators": "Показатели",
    "allCategories": "Все категории",
    "allLocations": "Все места",
    "allStatuses": "Все статусы",
    "allSources": "Все источники",
    "empty": "Устройств нет",
    "categoryFilter": "Фильтр по категории",
    "locationFilter": "Фильтр по месту",
    "statusFilter": "Фильтр по статусу",
    "sourceFilter": "Фильтр по источнику"
  },
  "sources": {
    "manual": "Вручную",
    "unified": "Единый сервер",
    "csv": "CSV-файл"
  },
  "monitoring": {
    "tabsLabel": "Разделы мониторинга данных",
    "devicesTab": "Сведения об устройствах",
    "physicalTab": "Мониторинг физических показателей",
    "virtualTab": "Мониторинг виртуальных показателей",
    "devicesTitle": "Сведения об устройствах",
    "physicalTitle": "Физические показатели",
    "virtualTitle": "Виртуальные показатели",
    "search": "Поиск по названию устройства",
    "filter": "Фильтр",
    "category": "Категория",
    "location": "Место установки",
    "name": "Название",
    "serial": "Серийный номер",
    "passport": "Паспорт калибровки",
    "formula": "Формула",
    "formulaYes": "Есть",
    "formulaNo": "Нет",
    "deviceName": "Устройство",
    "device": "Устройство",
    "time": "Время измерения",
    "value": "Значение",
    "sourceFile": "Источник",
    "unit": "Ед. изм.",
    "status": "Статус",
    "liveStatus": "Текущее состояние: {{status}}",
    "history": "История измерений",
    "emptyDevices": "Устройств нет",
    "emptyPhysical": "Физических показателей нет",
    "emptyVirtual": "Виртуальных показателей нет",
    "emptyVirtualHint": "Виртуальные показатели создаются формулой в разделе «Калибровка устройств».",
    "filterTitle": "Фильтр",
    "anyCategory": "Все категории",
    "anyLocation": "Все места",
    "anyStatus": "Все статусы",
    "reset": "Очистить",
    "openCalibration": "Перейти к калибровке"
  },
  "history": {
    "title": "История измерений",
    "range1d": "1 день",
    "range7d": "7 дней",
    "range30d": "30 дней",
    "rangeAll": "Все",
    "rangeLabel": "Период",
    "min": "Мин",
    "max": "Макс",
    "avg": "Среднее",
    "last": "Последнее",
    "count": "Измерений: {{count}}",
    "empty": "За этот период измерений нет",
    "noRight": "У вас нет прав на просмотр истории",
    "lastUpdate": "Обновлено: {{time}}"
  }
}
